module.exports = __webpack_public_path__ + "static/media/person.cb2b6d56.png";